@if (!newTabMode) {
  <button mat-icon-button class="close-button" [mat-dialog-close]="" matTooltip="sluiten">
    <mat-icon>clear</mat-icon>
  </button>
}
<iframe class="iframe" [src]="iframeSafeUrl" frameborder="0"></iframe>
